import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'proportionality_advanced',
    dependencies: [
        'levels_maths/proportionality_negatives'
    ]
})


function common (q, leftA, rightA, ratio) {
    q.addText(leftA + ' -> ' + rightA)
    q.addText((leftA * ratio) + ' -> ANSWER_HERE')
    q.answer = rightA * ratio

    q.addBadChoices(
        leftA,
        rightA,
        rightA * rightA,
        leftA * ratio,
        leftA * rightA,
        ratio,
        rightA * (ratio + 1),
        rightA * ratio * 2,
        rightA * leftA * ratio,
        () => rightA * random.intBetween(ratio - 2, ratio + 2),
        () => random.intBetween(1, Math.min(leftA, rightA))
    )
}



level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: {leftA: 200,  rightA: 11, ratio: 2}},
            {1: {leftA: 1000, rightA: 7, ratio: 3}},
            {
                all: {
                    leftA:  [100, 1000, 200, 2000],
                    rightA: [7, 3, 11, 111, 1010, 222, 22],
                    ratio:  [2, 3, 4]
                }
            }
        ], function (choices) {
            common(q, choices.leftA, choices.rightA, choices.ratio)
        })
    }
})


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: {leftA: 2020, rightA: 13, ratio: 2}},
            {1: {leftA: 1100, rightA: 3, ratio: 3}},
            {
                all: {
                    leftA:  [1010, 1100, 1002, 2020, 2002, 2001, 10010],
                    rightA: [7, 3, 100, 200, 111, 222],
                    ratio:  [2, 3, 4]
                }
            }
        ], function (choices) {
            common(q, choices.leftA, choices.rightA, choices.ratio)
        })
    }
})


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: {leftA: 1111, rightA: 50, ratio: 2}},
            {1: {leftA: 2222, rightA: 7, ratio: 3}},
            {
                all: {
                    leftA:  [1111, 111, 222, 2222],
                    rightA: [5, 100, 101, 1001, 11, 200],
                    ratio:  [2, 3, 4]
                }
            }
        ], function (choices) {
            common(q, choices.leftA, choices.rightA, choices.ratio)
        })
    }
})





export default level

